// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { GameStateProvider } from './contexts/GameStateContext';
import { CargoProvider } from './contexts/CargoContext';
import { ModulesProvider } from './contexts/ModulesContext';
import { UniverseProvider } from './contexts/UniverseContext';
import { AlertProvider } from './contexts/AlertContext';
import { UIProvider } from './contexts/UIContext';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <GameStateProvider>
          <CargoProvider>
            <ModulesProvider>
              <UniverseProvider>
                <AlertProvider>
                  <UIProvider>
                    <Routes>
                      <Route path="/" element={<App />} />
                    </Routes>
                  </UIProvider>
                </AlertProvider>
              </UniverseProvider>
            </ModulesProvider>
          </CargoProvider>
        </GameStateProvider>
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
